"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentFragment = void 0;
exports.paymentFragment = `
  fragment payment on Payment {
    id
    balance
    debtInsurance
    dueDate
    fees
    installment
    interest
    paymentAmount
    period
  }
`;
//# sourceMappingURL=payment.js.map